import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/buttons/buttons";
import Input from "../../../components/inputs/inputs";
import { getUserBusinessIdFromCookies } from "../../../utils/Auth";
import Location from "../../../components/includes/location";
import LocationSearch from "../../../components/includes/locationSearch";
import { history } from "../../../helpers/history";
import { createAStore } from "./../../../redux/stores/storeActions";
import SelectableInput from "../../../components/inputs/SelectableInput";
import { getAllTags } from "../../../redux/productTags/productTagActions";
import { filterProductCategory } from "./../../../redux/productCatergory/productCategoryAction";
import { logoutUserLocallyAction } from "../../../plugins/axios.plugin";

export default function CreateStore() {
  const dispatch = useDispatch();
  const user_business_id = getUserBusinessIdFromCookies();

  const business_id = user_business_id || "";

  const [locationLoader, setLocationLoader] = useState(false);
  //This is used to get the list of region data ie: country, city and states
  const [locationId, setLocationId] = React.useState({
    country_id: "",
    state_id: "",
    city_id: "",
  });
  const [locationList, setLocationList] = React.useState({
    countryList: [],
    stateList: [],
    cityList: [],
  });
  const { allCategories } = useSelector((state) => state.productCatergory);
  const { allTags } = useSelector((state) => state.productTag);
  const { settings } = useSelector((state) => state.application);
  const useGooglePlaces = settings?.google_places_status === "available";

  useEffect(() => {
    dispatch(getAllTags(1));
    dispatch(filterProductCategory({ type: "store" }, 1));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const storeCategories = allCategories?.data?.filter((item) => {
    return item?.type === "store";
  });
  const storeTags = allTags?.data?.filter((item) => {
    return item?.type === "store";
  });
  const toJson = (value) => JSON.stringify(value);
  const fromJson = (value) => JSON.parse(value);

  const [submitted, setSubmitted] = useState(false);
  const [data, setData] = useState({
    store_email: "",
    store_name: "",
    store_address: "",
    store_city: "",
    store_state: "",
    store_country: "",
    store_description: "",
    store_categories: [],
    store_tags: [],
  });
  const {
    store_name,
    store_email,
    store_address,
    store_city,
    store_state,
    store_country,
    store_description,
    store_categories,
    store_tags,
  } = data;

  let [store_phone, setStorePhone] = useState("");
  store_phone = store_phone?.slice(1);

  const handleAddTags = (value) => {
    const former_tags = [...data?.store_tags];
    let new_tags = [...former_tags, value.name];
    setData({ ...data, store_tags: new_tags });
  };

  const handleAddCategories = (value) => {
    const former_categories = [...data?.store_categories];
    let new_categories = [...former_categories, value.name];
    setData({ ...data, store_categories: new_categories });
  };

  function handleRegion(e) {
    const { name, value } = e.target;
    setData((data) => ({ ...data, [name]: fromJson(value).name }));
  }
  const handleChange = (event) => {
    const { name, value } = event.target;
    event.preventDefault();
    if (name === "store_categories") {
      setData({ ...data, store_categories: [value] });
    } else {
      setData((data) => ({ ...data, [name]: value }));
    }
  };

  //This is used to set location if google places is active
  const handleSelectLocation = (place) => {
    setData((prev) => ({
      ...prev,
      store_address: place.address,
      store_city: place.city,
      store_state: place.state,
      store_country: place.country,
      store_latitude: place.lat,
      store_longitude: place.lng,
      store_zip: place.postalCode,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitted(true);
    if (
      store_name &&
      store_phone &&
      store_address &&
      store_categories &&
      store_city &&
      store_state &&
      store_country
    ) {
      // dispatch action to create data
      const response = await dispatch(
        createAStore({ ...data, store_phone, business_id: business_id })
      );
      if (response.status === "success") {
        logoutUserLocallyAction();
        history("/success");
      }
    }
  };

  return (
    <div>
      <div
        className="pt-4 sm:pt-2 sm:flex items-center mx-auto"
        data-test="createStoreComponent"
      >
        <div className=" max-w-4xl mx-auto mt-10">
          <div className="sm:w-[629px] w-full mt-10 sm:ml-10 sm:mt-0 sm:border px-6 pb-4 sm:border-gray-200">
            <form name="form" id="store_form" onSubmit={handleSubmit}>
              <div className="border-b-2 py-4 mb-6">
                <p className=" text-base font-medium text-gray-800 dark:text-white flex justify-center ">
                  Store Details
                </p>
              </div>

              <div className=" sm:px-10">
                <div
                  className={
                    "mt-4" + (submitted && store_name ? " border-red-500" : "")
                  }
                >
                  <Input.Label
                    title={"Store Name"}
                    htmlFor={"store_name"}
                    type={"text"}
                    name={"store_name"}
                    onChange={handleChange}
                    placeholder={"Enter store name"}
                  />
                  {submitted && !store_name && (
                    <div className="text-xs text-red-500">
                      Store name is required
                    </div>
                  )}
                </div>
                <div
                  className={
                    "mt-4" + (submitted && store_email ? " border-red-500" : "")
                  }
                >
                  <Input.Label
                    title={"Store Email *"}
                    htmlFor={"store_email"}
                    type={"email"}
                    name={"store_email"}
                    onChange={handleChange}
                    placeholder={"Enter store email address"}
                  />
                </div>

                <div
                  className={
                    "mt-4" + (submitted && store_phone ? " border-red-500" : "")
                  }
                >
                  <Input.Phone
                    defaultCountry="NG"
                    title={"Store Phone Number"}
                    htmlFor={"store_phone"}
                    value={store_phone}
                    onChange={setStorePhone}
                  />
                  {submitted && !store_phone && (
                    <div className="text-xs text-red-500">
                      Store phone is required
                    </div>
                  )}
                </div>
                {!useGooglePlaces && (
                  <div>
                    <div
                      className={
                        "mt-4" +
                        (submitted && store_address ? " border-red-500" : "")
                      }
                    >
                      <Input.Label
                        title={"Store Address *"}
                        htmlFor={"store_address"}
                        type={"text"}
                        name={"store_address"}
                        onChange={handleChange}
                        placeholder={"Enter store Address"}
                      />
                    </div>
                    {submitted && !store_address && (
                      <div className="text-xs text-red-500">
                        Store address is required
                      </div>
                    )}
                  </div>
                )}
                <div
                  className={
                    "mt-4" +
                    (submitted && store_description ? " border-red-500" : "")
                  }
                >
                  <Input.TextArea
                    title={"Store Description "}
                    htmlFor={"store_description"}
                    type={"text"}
                    name={"store_description"}
                    onChange={handleChange}
                    placeholder={"Describe your store to us"}
                  />
                </div>

                <div
                  className={
                    "mt-4" +
                    (submitted && store_categories ? " border-red-500" : "")
                  }
                >
                  <label
                    htmlFor="store_categories"
                    className="text-sm font-medium text-[#151515] dark:text-white"
                  >
                    Store Categories*
                  </label>
                  <SelectableInput
                    options={storeCategories}
                    label="store_categories"
                    name={"+ Add Category"}
                    type="category"
                    selectOption={handleAddCategories}
                  />
                </div>

                <div
                  className={
                    "mt-4" + (submitted && store_tags ? " border-red-500" : "")
                  }
                >
                  <label
                    htmlFor="store_tags"
                    className="text-sm font-medium text-[#151515] dark:text-white"
                  >
                    Store Tags*
                  </label>
                  <SelectableInput
                    options={storeTags}
                    label="store_tags"
                    name={"+ Add Tag"}
                    type="tag"
                    selectOption={handleAddTags}
                  />
                </div>

                <Location
                  country_id={locationId.country_id}
                  state_id={locationId.state_id}
                  city_id={locationId.city_id}
                  loadingLocation={(value) => {
                    setLocationLoader(value);
                  }}
                  countryList={(value) => {
                    setLocationList({ ...locationList, countryList: value });
                  }}
                  stateList={(value) => {
                    setLocationList({ ...locationList, stateList: value });
                  }}
                  cityList={(value) => {
                    setLocationList({ ...locationList, cityList: value });
                  }}
                />
                {useGooglePlaces && (
                  <div className="my-5">
                    <LocationSearch
                      onPlaceSelect={handleSelectLocation}
                      searchLocationTitle={"Search Store Location*"}
                    />
                  </div>
                )}

                <>
                  {/* country */}
                  <div className="mt-4">
                    <Input.Select
                      title={"Select Country*"}
                      name="country"
                      id="country"
                      className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
                      htmlFor={"country"}
                      value={store_country}
                      disabled={useGooglePlaces}
                      onChange={(e) => {
                        setLocationId({
                          ...locationId,
                          country_id: fromJson(e.target.value).id,
                        });
                        handleRegion(e);
                      }}
                    >
                      <option>
                        {store_country !== ""
                          ? store_country
                          : "Select Country"}
                      </option>
                      {locationLoader ? (
                        <option>Loading...</option>
                      ) : (
                        locationList?.countryList &&
                        locationList?.countryList?.length > 0 &&
                        locationList?.countryList?.map((item, key) => {
                          return (
                            <option
                              key={key}
                              value={toJson({
                                name: item.name,
                                id: item.id,
                              })}
                              className="dark:bg-[#121212] dark:text-white"
                            >
                              {item.name}
                            </option>
                          );
                        })
                      )}
                    </Input.Select>
                    {submitted && !store_country && (
                      <div className="text-xs text-red-500">
                        Country is required
                      </div>
                    )}
                  </div>

                  {/* state */}
                  <div className="mt-4">
                    <Input.Select
                      title={"Select State*"}
                      name="state"
                      id="state"
                      className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
                      htmlFor={"state"}
                      value={store_state}
                      disabled={useGooglePlaces}
                      onChange={(e) => {
                        setLocationId({
                          ...locationId,
                          state_id: fromJson(e.target.value).id,
                        });
                        handleRegion(e);
                      }}
                    >
                      <option>
                        {store_state !== "" ? store_state : "Select State"}
                      </option>
                      {locationLoader ? (
                        <option>Loading...</option>
                      ) : (
                        locationList?.stateList &&
                        locationList?.stateList?.length > 0 &&
                        locationList?.stateList?.map((item, key) => {
                          return (
                            <option
                              key={key}
                              value={toJson({
                                name: item.name,
                                id: item.id,
                              })}
                            >
                              {item.name}
                            </option>
                          );
                        })
                      )}
                    </Input.Select>
                    {submitted && !store_state && (
                      <div className="text-xs text-red-500">
                        State is required
                      </div>
                    )}
                  </div>

                  {/* city */}
                  <div className="mt-4 mb-10">
                    <Input.Select
                      title={"Select City*"}
                      name="city"
                      id="city"
                      className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
                      htmlFor={"city"}
                      value={store_city}
                      disabled={useGooglePlaces}
                      onChange={(e) => {
                        setLocationId({
                          ...locationId,
                          city_id: fromJson(e.target.value).id,
                        });
                        handleRegion(e);
                      }}
                    >
                      <option>
                        {store_city !== "" ? store_city : "Select City"}
                      </option>
                      {locationLoader ? (
                        <option>Loading...</option>
                      ) : (
                        locationList?.cityList &&
                        locationList?.cityList?.length > 0 &&
                        locationList?.cityList?.map((item, key) => {
                          return (
                            <option
                              key={key}
                              value={toJson({
                                name: item.name,
                                id: item.id,
                              })}
                            >
                              {item.name}
                            </option>
                          );
                        })
                      )}
                    </Input.Select>
                    {submitted && !store_city && (
                      <div className="text-xs text-red-500">
                        City is required
                      </div>
                    )}
                  </div>
                </>
              </div>
            </form>
          </div>

          <Button.Primary
            type={"submit"}
            form={"store_form"}
            title={"Submit"}
            className={"w-[333px] sm:mt-10 mx-auto flex justify-center  "}
          />
        </div>
      </div>
    </div>
  );
}
